import { router } from '@inertiajs/vue3';
import {ContnentEnum} from '@/Enums/ContentEnum.js';

export function goTo(element) {
	if (element.external) {
		window.open(element.url, element?.target ?? '_blank').focus();
	} else {
		if ([2,3].includes(Number(element.type1)) || [ContnentEnum.ARTICLES, ContnentEnum.TOOLS].includes(element.type_1)) {
			router.get('/library/tool/'+element.slug);
		} else {
			router.get('/library/'+element.id);
		}
	}
}

export function redirectOwnerPage(element) {
	// console.log('element', element);

	if (element.users && element.users.length) {
		redirectUserPage(element.users[0]);

	} else if (element.company) {
		redirectCompanyPage(element);
	} else {
		return false;
	}
}

export function redirectCompanyPage(element) {
	if (element.company.slug === 'ProductStar') {
		window.open('https://productstar.ru/', '_blank').focus();
	} else if (element.company.slug === 'productcamp') {
		window.open('https://productcamp.ru/', '_blank').focus();
	} else {
		if (element.company.side_menu) {
			router.get('/partners/'+element.company.slug);
		}
	}
}

export function redirectUserPage(user) {
	console.log('redirect to user home page');
}

export function redirect(url) {
	window.open(url, '_blank');
}

